import { FC, ReactNode } from 'react'

import NonCollapsable from '../../components/NonCollapsable'

import * as SC from './styled'

export type PlanningAboutSectionProps = {
  aboutTitle?: string
  aboutText?: ReactNode
}

const PlanningAboutSection: FC<PlanningAboutSectionProps> = ({
  aboutTitle,
  aboutText,
}) => {
  return (
    <NonCollapsable>
      <SC.About>
        {aboutTitle && (
          <SC.AboutTitle>
            <SC.AboutIcon icon="question" />
            <span>{aboutTitle}</span>
          </SC.AboutTitle>
        )}
        {aboutText && <SC.AboutContent>{aboutText}</SC.AboutContent>}
      </SC.About>
    </NonCollapsable>
  )
}

export default PlanningAboutSection
